import { Duration } from "dayjs/plugin/duration";
import deepFreeze from "deep-freeze-es6";

export type OperatingState = Readonly<{
  max: { value: number | null; unit: string };
  time: Duration;
}>;

export function makeOperatingState(
  maxValue: number | null,
  unit: string,
  time: Duration
): OperatingState {
  return deepFreeze({ max: { value: maxValue, unit: unit }, time: time });
}

export type LoadDuration = Readonly<{
  unit: string;
  data: Array<{ time: Duration; value: number | null }>;
}>;
